import { useContext } from 'react'
import PropTypes from 'prop-types'
import { AccordionContext, useAccordionButton } from 'react-bootstrap'

const ContextAwareToggle = ({
  children = undefined, eventKey, callback = undefined, buttonClass = '', disabled = false
}) => {
  const currentEventKey = useContext(AccordionContext)
  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey))
  const isCurrentEventKey = currentEventKey.activeEventKey === eventKey

  return (
    <button
      type="button"
      className={`${buttonClass} d-flex align-items-center${isCurrentEventKey ? ' opened' : ''}`}
      onClick={decoratedOnClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

ContextAwareToggle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  eventKey: PropTypes.string.isRequired,
  callback: PropTypes.func,
  buttonClass: PropTypes.string,
  disabled: PropTypes.bool
}

export default ContextAwareToggle
